<div style="margin: 30px 0">
  <div class="light-blue-text otsikko">Riskiarvio</div>

  @for (historia of riskiarvioHistoriatObservable | async; track historia) {
    <div class="cont info-box" style="margin-bottom: 10px">
      <mat-radio-group style="max-width: 200px" [value]="historia.riskiarvio" [disabled]="true">
        <mat-radio-button value="'vahainen'">Vähäinen riski</mat-radio-button>
        <mat-radio-button value="'kohonnut'">Kohonnut riski</mat-radio-button>
        <mat-radio-button value="'korkea'">Korkea riski</mat-radio-button>
      </mat-radio-group>
      <mat-form-field style="max-width: 330px">
        <mat-label>Lisätietoja</mat-label>
        <textarea matInput [value]="historia.risikiarvioLisa" [disabled]="true" cdkTextareaAutosize></textarea>
      </mat-form-field>
    </div>
    <div style="margin-bottom: 50px; font-size: 11px">{{ historia.paivittajanNimi }} ({{ historia.paivitettyString }})</div>
  }

  <form>
    @if (tehdaanUusiRiskiarvio()) {
      <div class="cont info-box">
        <mat-radio-group style="max-width: 200px" [formField]="lomake.riskiarvio" aria-label="Valitse">
          <mat-radio-button value="'vahainen'">Vähäinen riski</mat-radio-button>
          <mat-radio-button value="'kohonnut'">Kohonnut riski</mat-radio-button>
          <mat-radio-button value="'korkea'">Korkea riski</mat-radio-button>
        </mat-radio-group>
        <mat-form-field style="max-width: 330px">
          <mat-label>Lisätietoja</mat-label>
          <textarea matInput [formField]="lomake.riskiarvioLisa" cdkTextareaAutosize></textarea>
        </mat-form-field>
        @if (riskiarvioEditActiveErrorsObservable | async; as riskiarvioEditActiveErrors) {
          <div class="lemon-error">
            <div>Riskiarviota ei voida tehdä koska:</div>
            <ul>
              @if (riskiarvioEditActiveErrors.edustajaTunnistamatta) {
                <li>Asiakkaan edustaja on tunnistamatta</li>
              }
              @if (riskiarvioEditActiveErrors.kuvausPuuttuu) {
                <li>Kuvaus asiakkaan toiminnasta puuttuu</li>
              }
              @if (riskiarvioEditActiveErrors.tuntemistiedotAntamatta) {
                <li>Asiakasyhtiön tuntemistiedot on antamatta</li>
              }
            </ul>
          </div>
        }
      </div>
    }
  </form>

  <div class="button-container">
    <app-button (click)="triggerRiskiarvioEdit()" [dynamicClass]="{ secondarybutton: tehdaanUusiRiskiarvio(), primarybutton: !tehdaanUusiRiskiarvio() }" action="Avaa riskiarvio valikko/Peruuta">{{ tehdaanUusiRiskiarvio() ? 'Peruuta' : 'Tee uusi riskiarvio' }}</app-button>
    @if (tehdaanUusiRiskiarvio()) {
      <app-primary-button (click)="tallenna()" actionId="Tallenna asiakkaan riskiarvio" [actionContext]="$any(lomake().value())" styles="margin-bottom: 10px;">Tallenna</app-primary-button>
    }
  </div>
</div>
